import {Component, Input} from '@angular/core';
import {MatButton, MatButtonModule} from "@angular/material/button";
import {MatCard, MatCardModule} from "@angular/material/card";
import {MatDivider, MatDividerModule} from "@angular/material/divider";
import {MatIcon, MatIconModule} from "@angular/material/icon";
import {CommonModule, NgIf} from "@angular/common";
import {TaskModel} from "../../../../../domain/models/task.model";
import {StatusIndicatorComponent} from "../../../../../common/status-indicator/status-indicator.component";
import {
  RequestTypeIndicatorComponent
} from "../../../../../common/request-type-indicator/request-type-indicator.component";
import {
  EnrollmentTypeIndicatorComponent
} from "../../../../../common/enrollment-type-indicator/enrollment-type-indicator.component";
import {EnrollmentTypeIntMap} from "../../../../../domain/enums/enrollment-type.enum";

@Component({
  selector: 'app-task-detail-header',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    StatusIndicatorComponent,
    RequestTypeIndicatorComponent,
    EnrollmentTypeIndicatorComponent
  ],
  templateUrl: './task-detail-header.component.html',
  styleUrl: './task-detail-header.component.css'
})
export class TaskDetailHeaderComponent {
  @Input() currentTask: TaskModel | undefined;
  protected readonly EnrollmentTypeIntMap = EnrollmentTypeIntMap;
}
